import { h } from "@stencil/core";

export const ChevronLeft = () => (
    <svg viewBox='0 0 48 48' role='img' fill='currentColor'>
        <path d='M23.932,40l4,0l-9.6-16l9.6-16l-4,0l-9.6,16L23.932,40z'></path>
    </svg>
);
